module.exports = __webpack_public_path__ + "static/media/calc-logo.24db57c4.svg";